import * as React from "react";

import { LocalizationProvider, ProminentErrorProvider } from "../Common";

import {
  AboutContentProvider,
  ContentRouteProvider,
  GiftcardBalanceProvider,
  GiftcardPurchaseProvider,
  ReactGiftCardInitialStateProvider,
} from "./providers";

import { Page } from "./Page";

interface AppProps {
  mountElement: Element | null;
}

export const App: React.FunctionComponent<AppProps> = (props) => {
  return (
    <React.Fragment>
      <ProminentErrorProvider>
        <ReactGiftCardInitialStateProvider mountElement={props.mountElement}>
          <LocalizationProvider>
            <ContentRouteProvider>
              <GiftcardPurchaseProvider>
                <GiftcardBalanceProvider>
                  <AboutContentProvider>
                    <Page />
                  </AboutContentProvider>
                </GiftcardBalanceProvider>
              </GiftcardPurchaseProvider>
            </ContentRouteProvider>
          </LocalizationProvider>
        </ReactGiftCardInitialStateProvider>
      </ProminentErrorProvider>
    </React.Fragment>
  );
};
